import { apiPrefix } from "@/config/config";
import { api, authApi } from "../interceptor/api.interceptor";

class UserService {
  // Public routes
  static async sendOtp(data) {
    return await api
      .post(`/${apiPrefix}/send-otp`, data)
      .then((res) => res?.data?.data);
  }
  static async sendRegOtp(data) {
    return await api
      .post(`/${apiPrefix}/send-reg-otp`, data)
      .then((res) => res?.data?.data);
  }
  static async forgetPassword(data) {
    return await api
      .post(`/${apiPrefix}/forget-password`, data)
      .then((res) => res?.data?.data);
  }

  static async verifyOtp(data) {
    return await api
      .post(`/${apiPrefix}/verify-otp`, data)
      .then((res) => res?.data?.data);
  }

  static async register(data) {
    return await api
      .post(`/${apiPrefix}/register`, data)
      .then((res) => res?.data?.data);
  }

  static async login(data) {
    return await api.post(`/${apiPrefix}/login`, data).then((res) => res?.data);
  }

  // Authenticated routes
  static async getProfile() {
    return await authApi
      .get(`/${apiPrefix}/student/profile`)
      .then((res) => res?.data?.data);
  }

  static async updateProfile(formData) {
    return await authApi
      .post(`/${apiPrefix}/student/profile`, formData)
      .then((res) => res?.data?.data);
  }

  static async updatePassword(data) {
    return await authApi
      .post(`/${apiPrefix}/student/update-password`, data)
      .then((res) => res?.data?.data);
  }

  // Authenticated routes
static async getDashboardInfo(params = {}) {
  return await authApi
    .get(`/${apiPrefix}/student/dashboard`, {
      params: params,
    })
    .then((res) => res?.data?.data);
}

 


  static async getRoutines(params) {
    return await authApi
      .get(`/${apiPrefix}/student/routineInfo`, {
        params,
      })
      .then((res) => res?.data?.data);
  }

  static async allExams() {
    return await authApi
      .get(`/${apiPrefix}/student/allExams`)
      .then((res) => res?.data?.data);
  }

  static async allAdmittedCourse() {
    return await authApi
      .get(`/${apiPrefix}/student/all/courses`)
      .then((res) => res?.data?.data);
  }

  static async getPositions(params) {
    return await authApi
      .get(`/${apiPrefix}/student/result-position`, { params })
      .then((res) => res?.data?.data)
      .catch((err) => {
        console.error("Failed to fetch positions:", err);
        throw err;
      });
  }
  static async getResult(params) {
    return await authApi
      .get(`/${apiPrefix}/student/results`, { params })
      .then((res) => res?.data?.data)
      .catch((err) => {
        console.error("Failed to fetch positions:", err);
        throw err;
      });
  }

  static async getMyCourseDetails(courseSlug, subjectSlug) {
    try {
      return await authApi
        .get(
          `/${apiPrefix}/student/courses/${courseSlug}/subject/${subjectSlug}`
        )
        .then((res) => res?.data?.data);
    } catch (error) {}
  }

  static async studentReviews(formData) {
    return await authApi
      .post(`/${apiPrefix}/student/lecture-review`, formData)
      .then((res) => res?.data?.data);
  }

  static async updateLectureReview(id, data) {
    return await authApi
      .put(`/${apiPrefix}/student/lecture-review/update/${id}`, data)
      .then((res) => res?.data?.data);
  }

  static async studentLessonNote(formData) {
    return await authApi
      .post(`/${apiPrefix}/student/lesson-note/submit`, formData)
      .then((res) => res?.data?.data);
  }
  static async sendMessages(formData) {
    return await authApi
      .post(`/${apiPrefix}/student/messages`, formData)
      .then((res) => res?.data?.data);
  }

  static async getMessages(params = {}) {
    console.log("params", params);
    return await authApi
      .get(`/${apiPrefix}/student/messages`, { params })
      .then((res) => res?.data)
      .catch((err) => {
        console.error("Failed to fetch messages:", err);
        throw err;
      });
  }

  static async payment(formData) {
    return await authApi
      .post(`/${apiPrefix}/student/payment`, formData)
      .then((res) => res?.data?.data);
  }

  static async couponApplied(formData) {
    return await authApi
      .post(`/${apiPrefix}/student/coupon-applied`, formData)
      .then((res) => res?.data.data);
  }
  static async coursePendingPayment(formData) {
    return await authApi
      .post(`/${apiPrefix}/student/payment/pending`, formData)
      .then((res) => res?.data.data);
  }

  static async getPaymentHistory(status, page = 1, perPage = 1) {
    return await authApi
      .get(
        `/${apiPrefix}/student/payment/history?status=${status}&page=${page}&per_page=${perPage}`
      )
      .then((res) => res?.data?.data);
  }


    static async getallPaymentHistory(status, page = 1, perPage = 1) {
    return await authApi
      .get(
        `/${apiPrefix}/student/payment/all/history?status=${status}&page=${page}&per_page=${perPage}`
      )
      .then((res) => res?.data?.data);
  }

  static async getVdoOtp(videoId) {
    return await authApi
      .get(`/${apiPrefix}/student/vdocipher/otp/${videoId}`)
      .then((res) => res?.data)
      .catch((err) => {
        console.error("Error fetching VdoCipher OTP:", err);
        return null;
      });
  }

  static async getZoomLinkByMaterial(materialId) {
    console.log("materialId", materialId);
    return await authApi
      .post(`/${apiPrefix}/student/zoom-link`, {
        material_id: materialId,
      })
      .then((res) => res?.data?.url);
  }
  static async getSecureZoomlogin(materialId) {
    console.log("materialId", materialId);
    return await authApi
      .get(`/${apiPrefix}/student/secure/zoom/join/${materialId}`)
      .then((res) => res?.data?.url);
  }

  static async getNotifications(params = {}) {
    return await authApi
      .get(`/${apiPrefix}/student/notifications`, { params })
      .then((res) => res?.data?.data);
  }

  static async markNotificationAsRead(notificationUserId) {
    return await authApi
      .post(`/${apiPrefix}/student/notifications/read`, {
        notification_user_id: notificationUserId,
      })
      .then((res) => res?.data?.data);
  }

  static async markAttendance(formData) {
    return await authApi
      .post(`/${apiPrefix}/student/attendance`, formData)
      .then((res) => res?.data?.data);
  }


    static async lectureReviews(materialID,routineId) {
    return await authApi
      .get(`/${apiPrefix}/student/lecture-review/${materialID}/${routineId}`)
      .then((res) => res?.data?.data);
  }

}

export default UserService;
